import styled from '@emotion/styled';
import HeaderCart from '../HeaderCart';

export const StyledHeaderCart = styled(HeaderCart)`
  position: absolute;
  right: 20px;
  top: 20px;
`;
